<template>
  <span
    :class="[sizeClasses, modeClasses, custom, isLoading, {'!cursor-not-allowed': disabled}]"
    class="cbutton group"
    >
      <base-icon
        :name="name"
        :size="iconSize"
        :title="titleIcon"
      />
  </span>
</template>

<script>
export default {
  name: 'base-button-icon',
  props: {
    name: {
      type: String,
      require: true
    },
    mode: {
      type: String,
      default: 'primary-phantom'
    },
    iconSize: {
      type: String,
      default: 'md'
    },
    size: {
      type: String,
      default: 'lg'
    },
    custom: {
      type: [String, Object],
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    titleIcon: {
      type: String,
      default: '',
    },
    focusable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners
      }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    isLoading: function () {
      return { 'loader-in-element': this.loading }
    },
    sizeClasses: function () {
      return {
        'w-8 h-8': this.size === 'xs',
        'w-10/5 h-10/5': this.size === 'md',
        'h-11 w-11': this.size === 'lg',
        'h-12 w-12': this.size === 'xl',
        'h-14 w-14': this.size === 'xxl',
      }
    },
    modeClasses: function () {
      return {
        'cbutton--primary': this.mode === 'primary',
        'cbutton--secondary text-white bg-secondary dark:bg-darkblue-600 hover:bg-secondary-500 dark:hover:bg-darkblue-500 active:bg-secondary-800 dark:active:bg-darkblue focus:bg-secondary-100 focus:text-secondary dark:focus:bg-secondary-100': this.mode === 'secondary',
        'cbutton--prim-phantom bg-primary-50 dark:bg-darkblue text-primary hover:text-primary-800 dark:hover:text-white hover:bg-primary-100 dark:hover:bg-primary-500 focus:bg-primary-50 focus:text-primary-800': this.mode === 'primary-phantom',
        'cbutton--core bg-white dark:bg-darkblue text-secondary dark:text-darkblue-200 hover:bg-primary-50 dark:hover:bg-darkblue-600 hover:text-primary dark:hover:text-primary active:bg-primary-50 active:text-primary focus:bg-primary-50 focus:text-primary': this.mode === 'core',
        'cbutton--sec-phantom-blue bg-secondary-50 dark:bg-darkblue-600 text-secondary dark:text-darkblue-100 hover:bg-primary-600 hover:text-white dark:hover:bg-primary-600 dark:hover:text-white focus:text-white focus:bg-primary-600 dark:focus:bg-primary-600': this.mode === 'secondary-phantom-blue',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cbutton {
  @apply flex items-center justify-center rounded-full cursor-pointer transition-colors duration-300 focus:outline-none focus:ring-0 focus:border-2 focus:border-black dark:focus:border-white;
  &.cbutton--primary {
    @apply text-white bg-primary hover:bg-primary-900 active:bg-primary-900 focus:bg-primary-900;
  }
  &.cbutton--core {
    @apply focus:outline-none;
  }
}
button {
  &:active {
    transform: scale(0.9);
  }
}
</style>
